/* unplugin-vue-components disabled */import script from "./blogDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./blogDetails.vue?vue&type=script&setup=true&lang=js"

import "./blogDetails.vue?vue&type=style&index=0&id=8743ec00&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\hello_world\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8743ec00"]])

export default __exports__